export const EXCEECEDS_BALANCE_LIMIT = 'exceedsBalanceLimit.th';
